import React from "react";
import { Heading } from "../../design/heading";
import { useConversation } from "../../contexts/ConversationContext";
import CreateConversationButton from "./components/CreateConversationButton";
import LoadingView from "../../components/LoadingView";
import ErrorView from "../../components/ErrorView";
import { useMatter } from "../../contexts/MatterContext";
import NoMatterView from "../../components/NoMatterView";
import ConversationListItem from "./components/ConversationListItem";
import EmptyStateView from "../../components/EmptyStateView";

const ConversationListPage: React.FC = () => {
  const { currentMatterId } = useMatter();
  const { conversations, error, loading } = useConversation();

  if (!currentMatterId) return <NoMatterView />;
  if (loading.list) return <LoadingView title="Loading Conversations" />;
  if (error.list) return <ErrorView error={error.list} />;

  return (
    <div className="flex flex-col gap-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <Heading>Inbox</Heading>
        <CreateConversationButton />
      </div>

      {/* Empty State */}
      {conversations.length === 0 ? (
        <div className="pt-12">
          <EmptyStateView
            title="No Conversations found"
            message="Create a conversation to get started."
          />
        </div>
      ) : (
        <div className="flex flex-col shadow-sm flex-coldivide-y">
          {conversations.map((conversation) => (
            <ConversationListItem
              key={conversation._id}
              conversation={conversation}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ConversationListPage;
